import {RestApiService} from '../../../rest-api.service';
import {SettingsDetailRes, SettingsUpdateReq} from '../../../../contracts/v0/crm/settings.contract';
import {ApiV0Crm} from '../api.v0.crm';

export class ApiV0CrmUser {
    segment = "/user"

    constructor(v0: ApiV0Crm, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
    }

    getSettings() {
        return this.rest.get<SettingsDetailRes>(`${this.segment}/settings`, SettingsDetailRes);
    }

    updateSettings(updateReq: SettingsUpdateReq) {
        return this.rest.patch<SettingsUpdateReq, SettingsDetailRes>(`${this.segment}/settings`, SettingsDetailRes, updateReq);
    }

    addFavouriteTask(id:string){
        return this.rest.post<string,string>(`${this.segment}/settings/favProject`, Number, id)
    }
}
